import DataKeyEdge from '@/edges/DataKeyEdge';
import type { AppEdge } from '@/edges/types';
import DataKeyEdgeForm from '@/form/DataKeyEdgeForm';
import type { AppEdgeType, SpaceId } from '@rock/types';
import type { EdgeTypes } from '@xyflow/react';
import type { ComponentType } from 'react';

export * from './types';

export const edgeTypes = {
    dataKey: DataKeyEdge,
} satisfies EdgeTypes;

export const edgeFormTypes: Record<AppEdgeType, ComponentType<EdgeFormProps<any>>> = {
    dataKey: DataKeyEdgeForm,
};

export type EdgeFormProps<T extends AppEdge> = {
    spaceId: SpaceId;
    flowId: string;
    edge: T;
    updateEdge: (edge: T) => Promise<void>;
    cancelUpdate: () => void;
};
